// src/pages/Admin/AdminSettings.tsx
import React, { useState } from 'react';
import { Shield, DollarSign, Clock, Save } from 'lucide-react';
import toast from 'react-hot-toast';

const AdminSettings: React.FC = () => {
  const [settings, setSettings] = useState({
    platformFee: 10,
    orderTimeout: 15,
    maxPrice: 10000,
    minPrice: 100,
    city: 'Osogbo',
  });

  const handleSave = () => {
    // In a real app, call API to save settings
    toast.success('Settings saved (mock)');
  };

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Platform Settings</h1>

      <div className="bg-white rounded-2xl p-6 shadow-lg max-w-2xl">
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-1">
              <DollarSign className="h-4 w-4" />
              Platform Fee (%)
            </label>
            <input
              type="number"
              value={settings.platformFee}
              onChange={(e) => setSettings({ ...settings, platformFee: parseInt(e.target.value) || 0 })}
              className="w-full px-4 py-2 border rounded-lg"
              min="0"
              max="100"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-1">
              <Clock className="h-4 w-4" />
              Order Acceptance Timeout (minutes)
            </label>
            <input
              type="number"
              value={settings.orderTimeout}
              onChange={(e) => setSettings({ ...settings, orderTimeout: parseInt(e.target.value) || 0 })}
              className="w-full px-4 py-2 border rounded-lg"
              min="1"
              max="60"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Max Price (₦)</label>
            <input
              type="number"
              value={settings.maxPrice}
              onChange={(e) => setSettings({ ...settings, maxPrice: parseInt(e.target.value) || 0 })}
              className="w-full px-4 py-2 border rounded-lg"
              min="100"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Min Price (₦)</label>
            <input
              type="number"
              value={settings.minPrice}
              onChange={(e) => setSettings({ ...settings, minPrice: parseInt(e.target.value) || 0 })}
              className="w-full px-4 py-2 border rounded-lg"
              min="50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Operating City</label>
            <input
              type="text"
              value={settings.city}
              onChange={(e) => setSettings({ ...settings, city: e.target.value })}
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>

          <button
            onClick={handleSave}
            className="w-full py-3 bg-gradient-to-r from-emerald-600 to-green-600 text-white font-bold rounded-xl hover:from-emerald-700 hover:to-green-700 flex items-center justify-center gap-2"
          >
            <Save className="h-5 w-5" />
            Save Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;